import { gql } from '@apollo/client';

export const LINK_FRAGMENT = gql`
  fragment linkFields on Link {
    channelKey
    isAdmin
    metadata {
      hasMinimalAndroidVersionForVideoCall
      hasMinimalArdoizCoreVersionForVideoCall
      subscriptionEnabled
    }
    type
    mainUser {
      id
      key
      firstName
      lastName
      emails
      postalAddress {
        address
        city
        zipcode
      }
    }
    selfWebUserId
    userKey
  }
`;

export const WEB_USER_FRAGMENT = gql`
  fragment webUserFields on WebUser {
    id
    firstName
    lastName
    email
    links {
      ...linkFields
    }
    onBoardingCompleted
  }
  ${LINK_FRAGMENT}
`;

export const WEB_USER_CONTACT_FRAGMENT = gql`
  fragment WebUserContact on WebUser {
    id
    firstName
    lastName
  }
`;